import tw, { styled } from "twin.macro"

const Tag = styled.div`
  ${tw`font-display text-white text-center uppercase p-1 inline-block`}
  font-size: 9.6px;
  line-height: 10px;
  padding-top: 6px;

  ${"" /* Default color is red */}
  background: linear-gradient(315deg, #e3284c 0%, #aa0024 100%);
  box-shadow: 0 3px 8px 0 rgba(170, 0, 36, 0.5);

  &.small {
    font-size: 9px;
    line-height: 9px;
    padding: 3px;
    padding-top: 3px;
    padding-bottom: 3px;
    margin-bottom: 3px;
    margin-left: 5px;
    vertical-align: middle;
    padding-top: 4px;
    padding-bottom: 2px;
  }

  &.large {
    ${tw`px-2`}
    font-size: 15px;
    line-height: 17px;
    padding-top: 5px;
  }

  &.medium {
    margin-left: 5px;
    transform: scale(1.2);
  }

  ${({ background }) => background ? `background: ${background};` : ""}
  ${({ boxShadow }) => boxShadow ? `box-shadow: ${boxShadow};` : ""}

  &.black {
    background: linear-gradient(315deg, #2c2c2c 0%, #5a5a5a 100%);
    box-shadow: 0 3px 8px 0 rgba(56, 56, 56, 0.5);
  }

  &.blue {
    background: linear-gradient(315deg, #3498db 0%, #006aa9 100%);
    box-shadow: 0 2px 4px 0 rgba(52, 152, 219, 0.5);
  }

  &.purple {
    background: linear-gradient(315deg, #b070fd 0%, #6d3cad 100%);
    box-shadow: 0 3px 8px 0 rgba(176, 112, 253, 0.6);
  }

  &.red {
    background: linear-gradient(315deg, #e3284c 0%, #aa0024 100%);
    box-shadow: 0 3px 8px 0 rgba(170, 0, 36, 0.5);
  }

  &.yellow {
    background: linear-gradient(315deg, #f7bf36 0%, #876718 100%);
    box-shadow: 0 2px 4px 0 rgba(135, 103, 24, 0.51);
  }

  &.shadow {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.5);
  }
`

export default Tag
